import React, { FC } from 'react'

import { Header, PdfViewer } from 'components'
import { Page } from 'common'

import { usePdfViewerPage } from '../hooks/usePdfViewerPage'

export const PdfViewerPage: FC = () => {
  const { title, file, onDownloadFile } = usePdfViewerPage()

  return (
    <Page>
      <Header
        title={title}
        rightIcon={{
          iconRef: 'core/action-navigation/ic_arrow_download',
          color: 'var(--primary500)',
          size: 24,
          onClick: onDownloadFile,
        }}
      />
      <PdfViewer url={file.url} />
    </Page>
  )
}
